module.exports = __webpack_public_path__ + "static/media/pharmacore remove bg.17118d39.png";